import { cn } from "@dalmatech/ui"

const root = (hasMultiPets: boolean) =>
  cn("flex flex-col gap-6 lg:gap-8  mx-auto", "md:w-[36.750rem] w-full pb-24")
const wrapper = cn("flex flex-col gap-6 lg:gap-8")
const cardsList = cn("flex flex-col gap-4 md:gap-6 w-full")
const ctaWrapper = (isDocked = false) =>
  cn("flex justify-center items-center w-full gap-3", isDocked ? "md:w-[36.750rem] w-full" : null)

export { cardsList, ctaWrapper, root, wrapper }
